import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { TopCard } from '../api/dto/top-card';

@Injectable({
    providedIn: 'root',
})
export class TopCardService {
    constructor(private http: HttpClient) { }

    private url : string = UrlServidor.URL_BASE + 'dashboards/cards';

    totalUsuariosLogadosDia(): Observable<TopCard>{
        return this.http.get<TopCard>(this.url + '/totallogins-dia');
    }

}